module.exports = {
    lang: {
        CN: '中文',
        EN: 'English'
    },

    login: {
        title: "用户注册",
        user_sign_in: "欢迎回来",
        welcome_to_login: "欢迎登录",
        // slogan: "iPassBill",
        password: "密码",
        auto_login_7_days: '7天内自动登录',
        forget_pwd: "忘记密码？",
        register_tip: "还没有账号？ 立即注册！",
        sign_in: "登录",
        previous: "返回上一步"

    },

    login_footer: {
        name:'iPassWallet',
        copy_right: "版权所有"
    },


     //二因子验证组件
    two_fa_code:{
        pls_enter_code:'请输入你的2步认证验证码 ',
        tips:'打开您的Authenticator应用查看您的验证码。',
        need_bind_text:'您需要启用两步验证，以访问平台的全部功能！',
        text1:'请用手机打开对应的Authenticator应用，扫描此条形码以设置您的账户。',
        text2:'请用手机打开对应的Authenticator应用，输入此代码以设置您的账户。',
        text3:'改为扫描条形码',
        text4:'改为手动输入代码',
        next:'下一步',
        bind_now:"立即绑定",
        limit:'没有权限!',
        contactus:'联系我们',
        download:'下载',
        developer:'开发者',
        recommend:'推荐',
        question:'如何设置账户两步认证？',
        step1:'请根据您使用的手机类型，在Apple Store或者Google Play搜索以下任意一款APP并安装。',
        step2:'打开以上任意一款已经安装好的APP，点击本页上方的“立即绑定”按钮，在弹出的对话框中，用已安装好的APP去扫描对话框中的二维码，或切换到手动输入条形码编码。操作完成，APP的界面就能看到6个随着时间随机变化的数字，如图：',
        step3:'点击对话框中的按钮“下一步”，再弹出的对话框中，输入APP中出现的6个数字，如提示“操作成功”，则表明两步认证操作已经完成。请妥善保存两步认证的APP和验证码，以后登录平台或进行一些敏感操作的时候，都会使用得到。'
    },

    register: {
        free_register: '免费注册',
        slogan: "输入一个有效邮箱和昵称，即刻完成注册！",
        company_account: "ISP服务商",
        personal_account: "代理商",
        actype: '',
        step1: "选择账户类型",
        step2: "验证邮箱，提交",
        
        fill_information: "请填写下列所有信息",
        pls_fill_isp_name: "请填写ISP名称",
        image_captcha: "图形验证码",
        email_captcha: "邮箱验证码",
        pls_fill_captcha: "请填写验证码",
        password: "密码",
        sign_up: "注册",
        login_tip: "已经有账号",
        first_name: "名",
        last_name: "姓",
        send_captcha: "发送邮件OTP",
        resend: '重新发送',
        name: '姓名',
        created_account:'立即创建您的 {name} 账户',
    },

    forget: {
        confirm_password: "确认密码",
        confirm_change: "确定修改",
        retrieve_pwd: "重置您的登陆密码",
        retrieve_pwd_easy: '通过向注册邮箱发送OTP，轻松重置登录密码。',
        get_pwd:'知道您的密码？'
    },

    home: {
        account_info: "账户信息",
        account_balance: "账户余额",
        balance: "余额",

        withdraw: "提现",
        deposit: "充值",
        transfer: "转账",
        collection: "收款",
        notice: "系统通知",
        overview_of_today: "今日概览",

        deposit_of_today: "充值",
        withdraw_of_today: "提现",
        transfer_of_today: "转出",
        collection_of_today: "转入",
        conversion_in_of_today: "买入",
        conversion_out_of_today: "卖出",
        transfer_list: "转账记录",
        collection_list: "收款记录",
        swap_list: "换汇记录",
        withdraw_list: "提现记录",
        deposit_list: "充值记录",
        unit: "笔",
        calcuated_at:'统计于',
        overviews_of_days:'{days}天概览',


    },
    // 导航
    menu: {
        home: "主页",//jan
        apps:'我的应用',//jan
        apps_info:'应用详情',

        transaction:'我的交易',//jan
        chargeback:'我的拒付',//jan
        ban:'拦截的交易',//jan


        all:'全部', 
        refundedlist:'退款列表',
        chargebacklist:'已拒付',
        banlist:'已拦截',
        fraudlist:'欺诈',



        withdraw: "提现",
        

        child_account:'子账户管理',




        rolling:'我的保证金',//jan
        statement: '我的对账单',//jan
        monthly_report:'月报表',
        notice: '系统通知',//jan
        shipping: '订单妥投',//jan
        shipping_list:"妥投列表",
        black:'我的黑名单',//jan
        white:'我的白名单', //jan

        // merchant_manage: '商户管理',
        // account:'账户管理',
        // merchant:'商户管理',
        
        // withdraw: '提现管理',
        // rolling: '保证金管理',
        


        // business_manage: '交易管理',
        // business:'交易列表',
        // // shipping:'物流公司',
        // expresslist:'妥投管理',

        // config_manage: '配置管理',
        // config:'全局配置',
        // exchange:'汇率管理',
        // channel:'渠道管理',
        // mid:'渠道MID',

        other_manage: '其他',
        
        // black:'黑名单管理',
        ban:'拦截记录',
        // white:'白名单管理',



        admin_manage: '管理员管理',
        member:'管理员列表',
        role:'角色管理',
        log:'日志管理',
            
        seeting: "账户设置",
        change_lang: "语言切换",
        logout: "退出",

    },

    
    common: {
        email: "邮箱",
        no_data: "暂时还没有数据哦~",
        hello: "你好，",
        currency: "货币",
        amount: "金额",
        fee: "手续费",
        confirm_transaction: "确认交易",
        trading_situation: "交易概况",
        enter_pay_pwd: "输入支付密码",
        confirm: "确认",
        helpful_hints: "Tips",//Jan
        transaction_reference: "交易附言",
        transaction_date: "交易日期",
        payee: '收款方',
        payer: '付款方',
        go_back: "返回",
        cancel: "撤回",
        name: '姓名',
        street: '街道',
        postcode: '邮编',
        legal_person_data: "法人资料",
        address: "您的地址",
        amtinfo: "用户信息",
        networkerror: '网络异常',
        close: '关闭',
        refresh: '刷新',
        checkInfo:'查看资料',
        note:'注意',
        system_update:'系统维护升级中',
        index_app_tips:'您至少需要添加一个应用，获得APP ID，以开始你的系统API集成工作！<span class="uk-text-primary">点击这里。</span>',
        click:'点击这里',
        withdraw_mode:'交易资金由第三方支付公司或者收单行直接清算！',
        auto_mode:'自动结算'

    },







    form: {
        ok:'确定',
        type:'类型',        
        save: '保存',
        search: "搜索",
        clear_con: "清除条件",
        submit: "提交",
        confirm: "确定",
        pls_select: "请选择",
        date: '时间',        
        email:'邮箱',
        time_range: "时间范围",
        status: "状态",
        amount_range: "金额范围",
        amount_min: "最小金额",
        amount_max: "最大金额",
        merchant_no:'商户号',
        currency:'货币',
        app_name:'APP名称',
        app_id:'APP ID',
        card_no:'银行卡号',
        credit_card:'信用卡',        
        order_time:'订单时间',
        update_time:'更新时间',

        created_at:'订单时间',
        released_at:'（预计）处理时间', 

        ms_no:'账单ID',
        serial_no:'流水号',
        relevant_no:'关联流水号',
        statement_type:'对账类型',
        channel:'渠道',
        order_no:'平台订单号',
        merchant_order_no:'商户订单号',
        gateway_order_no:'渠道订单号',
        front_six:'卡前六位',
        back_four:'卡后四位',
        company_name:'公司名称',
        shipping_no:'运单号',
        channel_id:'渠道ID',
        channel_version:'渠道版本',
        merchant_subject:"商户主体信息",
        merchant_subject_title:"商户主体",
        merchant_id:'上游渠道ID',
        channel_merchant:'上游渠道商户',
        bill_desc:'账单名称',
        title:'标题',
        is_visible:'是否可见',
        content:'内容',
        black_type:'黑名单类型',
        ban_code:'拦截code',
        ban_desc:'拦截说明',
        nick_name:'昵称',
        is_available:'是否可用',
        ip_address:'注册IP地址',
        ip:"IP",
        time_zone:'时区',
        first_lang:'首选语言',
        lang:'语言',
        company_name_2:'公司主体名称',
        balance:'余额',
        balance_range:'余额范围',
        frozen:'冻结',
        fee:'费率',
        released:'待释放保证金',
        country:'国家',
        services_cate:'行业',
        statement_id:'保证金ID',
        released_money:'释放金额',
        released_time:'待释放时间',
        balance_change:'余额变动',
        frozen_moeny:'冻结金额',
        frozen_moeny_index:"冻结金额",
        frozen_moeny_change:'冻结金额变动',
        business_type:'交易类型',
        remark:'备注',
        customer:'顾客',
        merchant:'商户',
        channel_title:'渠道信息',        
        channel_name:'渠道名称',
        web_site:'公司官网',
        api_resourse:'API网址',
        express_name:'货运公司',
        express_web:'货运公司网站',
        upload_time:'上传时间',
        exchange:'汇率',
        exchange_tips:'标记为结算货币的货币才可以作为商户的结算货币',
        is_settle_currency:'结算货币',
        support_currency:'支持货币',
        support_card_type:'支持卡种类型',
        is_available_refound:'部分退款',
        is_active:'是否激活',
        admin_team:'所属管理员组',
        express_time_range:'妥投时间范围',
        creat_busniess_time_range:'交易创建时间范围',
        chargeback_busniess_time_range:'交易拒付时间范围',
        refund_busniess_time_range:'交易退款时间范围',
        is_csv:"生成csv文件" ,
        download_csv:'下载csv',
        yes:'是',
        no:'否',
        create_time:'创建时间',
        api_title:'API信息',
        api_version:'API版本',
        api_secret:'API 秘钥',
        contact:'联系人',
        merchant_bill_desc:'商户账单信息',
        admin:'管理员',
        add_exchange:'新增汇率',
        update_exchange:'更新汇率',
        is_set_exchange_tips:'一般设置为结算货币，将不能再设置成非结算货币！',
        add_mid:'添加渠道MID',
        open:"开启",
        closed:'关闭',
        add_notice:'新增系统通知',
        add_black:'新增黑名单',
        add_member:'新增管理员',
        add_role:'新增角色',
        role_name:'管理组名',
        update_role:'更新角色组',
        role_limit:'分配权限',
        mode_name:"资源模块名",
        ass_team:'分配管理组',
        slidedown:"更多",
        slideup:'收起',
        release_now:'立即释放',
        ready_released_money:'待释放金额',
        already_released_money:'已释放金额',
        s_time:'统计时间',
        add:'新增',
        batchadd:'批量新增',
        is_released:'是否释放',
        black_value:'黑名单值',
        black_text:'当交易中的来源IP，国家，邮箱，电话至少有一个位于黑名单中，系统会直接拦截该笔交易！',
        test:'测试',
        refund_time:'退款时间',
        chargeback_time:'拒付时间',
        ban_time:'拦截时间',
        tot:'共{total}条',
        white_tips:'您可以添加信用卡卡号的前六位和后四位作为白名单，开启该功能，意味着只有符合白名单中的卡号规则的交易可以被平台接受！',
        order_success_time:'订单成功时间',
        order_failed_time:'订单失败时间',
        order_status_tips:'订单信息仅供参考,以最终的支付结果为准！',
        no_order_info:'抱歉,信息不存在!',        
        is_allow_support_direct_pay:'开启直连接口',
        trans_limits:'卡交易限制',
        app_add_msg:'App添加成功',
        is_default:'默认显示',     
        generate_report:'生成报表', 
        report_tips:'生成报表可能需要较长时间，您可以在点击生成报表按钮之后过一段时间再来查看。',
        receive_email:'接收邮箱',
        fraud_time_range:'交易欺诈时间范围',
        online:'线上',
        offline:'线下',
        edit:'编辑',
        full_refund:'全部退款',
        refund_statistic:'退款统计',
        refund_success:'退款成功',
        refund_accept:'退款已受理',
        refund_fail:'退款失败',
        include_refund:'含退款',
        without_refund:'不含退款',
        history_trans_profits:'历史交易收益',
        pay_method:'支付方式',
        pay_method:'支付场景',
        my_qrcode:'我的收款码',
        syn_asyn_url:'同步/异步通知地址',
        syn_url:'同步通知地址',
        asyn_url:'异步通知地址',
        refund_history:'退款历史',
        download_qr:'二维码下载',
        query_refund:'退款查询',

        choose_role:"选择角色",
        choose_mid:'选择商户',
        
    },

    setting: {
        basic_info: "基本信息",
        preferences: "首选项",
        security: "安全信息",
        user_name: "用户名称",
        tel:'联系号码',
        two_fa_code:"二因子秘钥",
        register_date: "注册时间",
        last_login_date:'上次登录时间',
        last_login_ip:'上次登录IP',
        last_login_app:'上次登录设备',

        default_language: "邮件语言",
        default_time_zone: "所在时区设置",
        login_pwd: "登录密码",
        two_step: "两步验证",
        change_pwd: "修改密码",
        new_pwd: "新密码",
        two_fa_secret:'二因子密钥',
        edit_email:'修改绑定邮箱',
        new_email:'新邮箱',
        email_tips:'修改邮箱后，需要重新登录及绑定二因子。',
        notice:'提示',
        notice_text:'您在使用账户过程中遇到的任何问题，都可以发送邮件到以下邮箱以寻求帮助！',
        version:'系统更新，请刷新获取最新版本',
        change_mid:'切换商户号',
        default:'默认',
        ord_stat:'状态',
    },

    
    

    

    error: {
        check_network: "请检查网络",
        no_resource: "资源不存在",
        sys_error: "系统错误",
    },

 

   //jan
    bottomtips:{
        a:'Email是注册帐户登录管理后台的唯一标识，您可以用他来找回密码或者沟通账户敏感问题。',
        b:'系统的商户号对应的某一个地区的企业实体信息，同一个账户号可以申请多个商户号，您至少应该激活其中一个用于实际的交易。',
        c:'应用，一般指的是商户的支付运营场景，一般分为“线上应用”和“线下应用”两种。线上应用一般指的是，在PC端，手机小程序，手机APP，手机浏览器中进行的支付操作，而线下应用一般指的是线下门店如超市，酒店，旅社等面对面的二维码，扫码枪，刷脸等支付场景。',
        d:'为了防止帐户被非法使用，我们强制启用两步验证，最大限度保证客户的账户和资金安全。',
        // e:'为了防止帐户被非法使用，我们强制启用两步验证，最大限度保证客户的资金安全。',
        // f:'如果您在使用系统的过程中有任何问题，都可以联系我们：support@ipassbill.com',

    },
  
    

    // 
    orderStatus:{
        1:'待处理  ',
        2:'支付成功', 
        3:'支付拒绝 ',
        4:'已授权 ',
        5:'已捕捉 ',
        6:'已取消  ',
        7:'等待退款 ',
        8:'已退款 ',
        9:'已拒付 ',
        10:'拒付撤销',
    },

    orderStatus_list:{
        Pending:'待处理  ',
        Approved:'支付成功', 
        Declined:'支付拒绝 ',
        Authorized:'已授权 ',
        Captured:'已捕捉 ',
        Voided:'已取消  ',
        Pending:'等待退款 ',
        Refunded:'已退款 ',
        Chargeback:'已拒付 ',
        Reversed:'拒付撤销',
    },

    // 
    errPsw:{
        pws_text:'密码长度要求8-20位且必须包含数字，大小写字母、特殊字符(#?!@$%^&*-).'
    },

    period_list:{
        0:'今日概览',
        1:'昨日概览',
        2:'本月概览',
        3:'上月概览',
        4:'全年概览',
    },

    blackTypeList:{
        1:'信用卡',
        2:'邮箱',
        3:'电话',
        4:'国家',
        5:'IP地址',
    },
    logtype:{
        1:'登录',
        2:'退出',
        3:'新增',
        4:'更新',
        5:'删除'
    },
    merchantStatus:{
        1:"待补充资料",
        2:"待审核",
        3:"已激活",
        4:"已禁用"
    },
    userStatus:{
        1:"已激活",
        2:"受限制",
        3:"已禁用",
    },
    merchants_tips:{
        tips:"建议值",
        tips_1:'当交易以商户主货币转化为通道货币的时候，通道金额额外增加的比例，默认m为0。例如商户的主货币为a，通道货币为b，假设1a=xb，且商户主货币金额正好等于1，那么正常情况下，通道金额b应该是(1+m)x，这里可以看到：m>=0，对于平台来说比较有利，以上情况对于a与b货币相同的情况，同样有效。',
        tips_2:'当交易订单的货币转化为商户账户主货币的时候，商户账户金额额外减少的比例，默认n为0。例如订单货币为a，商户主货币为b，假设1a=xb，且订单货币金额正好等于1，那么正常情况下，商户账户主货币金额应该是(1-n)x，这里可以看到：n<=0，对于平台来说比较有利。特别的，当a与b货币相同的情况，n不生效，也就是n直接为0.'
    },
    version_desc:{
        text:'版本'
    },
    version:{
        1:'1.0',
        2:'2.0',
        3:'3.0'    
    },
    pwd:{
        text:'留空表示保持密码不变！'
    },
    account_info:{
        pwd:'密码',
        reset_two_fa_code:'重置二因子',
        is_bind_two_fa_code:'启用2步验证？',
        admin_remark:'管理员备注',
        isp_remark:'ISP备注',
        // merchant_currency:'商户主货币',
        merchant_currency:'结算货币',
    },

    // 主体信息相关
    subject:{
        subject_title:'主体信息',
        company_name:'主体名称',
        entity_name:'公司名称',
        entity_tel:'公司电话',

        company_postcode:'公司所在地邮编',
        service_cate:'行业类型',
        service_cate_desc:'行业描述',
        company_address:'公司地址',
        person_address:"法人所在地址",
        legal_name:'法人姓名',
        legal_phone:'联系电话',
        legal_postcode:'法人所在地邮编',        
        web_site:'网址',
    },


    //商户详情. 变量暂时用1234，有个更好的在替换
    merchants_info:{
        merchant_title:'商户信息',
        // merchant_currency:'商户主货币',        
        merchant_currency:'结算货币',        
        limit_title:'限制信息',
        card_max_times:'单卡日最大交易次数', //单卡日限制次数
        card_success_times:'单卡最多可成功交易次数', //单卡日可支付次数
        bill_max_times:'单用户日最大交易次数', //单用户日可支付次数
        bill_success_times:'单用户日限制支付成功最大次数', //单用户日限制支付成功次数
        his_rolling:'历史保证金',

        trading_title:'交易相关',
        transaction_ratio_fee:'交易费率',
        transaction_roll_duration:'保证金期限',
        refund_fee:'退款费用',
        guaranty_duration:'结算周期',
        transaction_fixed_fee:'交易固定手续费',
        transaction_roll_ratio:'保证金比例',
        protest_fee:'拒付费用',

        factor_title:'汇差因子/交易因子',
        exchange_factor:'汇差因子',
        transaction_factor:'交易因子',
        
        withdraw_title:'提现相关',
        withdraw_ratio_fee:'提现费率',
        withdraw_fixed_fee:'提现手续费',
        withdraw_min_amount:'提现最小金额',
        withdraw_max_amount:'提现最大金额',
        is_withdrawal:'是否允许提现',
        is_allow_diff_bankaccount:'是否允许添加非同名银行帐户',
        day:'天',
        times:'次',
        no_see:'前台不可见',
        account_checking:'对账操作',
        download:'资料下载',        
        available_channel_mid:"可用渠道MID",
        inavailable_channel_mid:"不可用渠道MID",
        info:'商户详情',
        bank:'商户银行',
        white_card:"白名单",
        open_white_card:'开启白名单',
        limit_in:'可填范围0-100, 0表示不限制',
        apidoc:"API文档",
        withdrawal_frequency:'提现频率 (N)',
        currency_tips:'每个商户号可以设置唯一一种结算货币，且设置之后，后期无法修改，请在提交审核前务必确认你要结算的货币是什么。'


    },

    merchant_withdraw_type:{
        1:'次/日',
        2:'次/周',
        3:'次/月'
    },
     
    app_info:{
        type:"APP类型",
        card_type:"卡类型",        
        meta:'Meta 标识',
        order_currency:'订单货币',
        order_amount_range:'订单金额范围',
        channel_mid_info:'渠道MID信息',
        priority:'优先级',
        gateway_currency:'渠道结算货币',
        choose_channel:'渠道选择',
        failed_reason:'审核失败原因',
        need_delivery:'是否需要妥投',
     

    },  

    withdraw_info:{
        withdraw_title:'提现银行账户',
        bank_info:'银行信息',
        bank_account_number:'银行账号',
        bank_account_name:'银行账户名',
        bank_name:'银行名称',
        swift_code:'SWIFT',
        bank_branch:'中转行',
        bank_country:'银行国家',
        account_country:'提现人所在国',
        
        withdraw_title:'提现详情',
        check_withdraw:'审核提现',
        confirm_withdraw:'确认提现',    
        withdraw_tips:'当前账户未结算交易<span class="uk-text-danger">{total_deal_amount}</span> {merchant_currency}（<span class="uk-text-danger">{total_deal_count}</span>笔），未结算金额为<span class="uk-text-danger">{net_deal_amount}</span> {merchant_currency}。（<span class="uk-text-danger">{start_date}</span>-<span class="uk-text-danger">{end_date}</span>）',                
        // withdraw_tips:'从 <span class="uk-text-danger">{start_date}</span> 到 <span class="uk-text-danger">{end_date}</span> ,您目前成功交易为 <span class="uk-text-danger">{total_deal_count}</span> 笔 , 成功交易额 <span class="uk-text-danger">{total_deal_amount}</span> {merchant_currency} ,净结算金额 <span class="uk-text-danger">{net_deal_amount}</span> {merchant_currency}（押款金额）',
    },
    business_info:{
        basic_info:'基础信息',
        mode_desc:'交易模式',
        gateway_amount:'网关金额',
        gateway_available_amount:'网关剩余金额',
        risk_time:'风险发生时间',
        bill_desc:'账单信息',
        risk_desc:'风险描述',
        
        order_history:'订单历史',
        //merchant_amount:'商户结算金额',   
        merchant_amount:'结算金额',   
        // gateway_amount:'商户网关金额',
        
        rolling_title:'保证金',
        rolling_ratio:'保证金比例',
        rolling_back_day:'保证金返还天数',
        rolling_released_time:'保证金释放时间',
        rolling_ready_released_time:'预计释放时间',
        rolling_already_released_time:'释放时间',



        fee_title:'收费标准',
        exchange_roe:'汇差',
        gateway_roe:'兑换率',
        rolling_day:'押款周期',
        fixed_fee:'固定交易费',
        process_ratio:'交易费率',
        transaction_total_fee:'交易总费用',
        refund_fee:'退款费',
        protest_fee:'拒付费',
        
        card_title:'信用卡',
        card_holder:'持卡人',
        expiry_time:'过期时间',
        
        act_record:'操作记录',

        
        act_exception:'处理异常',
        
        success_btn:'处理为成功',
        refused_btn:'拒绝',
        authorization_btn:'授权',
        cancel_btn:'取消',
        refound_btn:'退款',
        catch_btn:'捕捉',
        cancle_refound_btn:'取消退款',
        cancle_channel_refound_btn:'取消渠道退款',
        over_refound:'完成退款',
        refuse_pay_btn:'拒付',
        cancel_chargeback:'撤销拒付',   
        refund_plan:'退款计划',
        action:'操作',
        gateway_serial_no:'渠道流水号',
        ignore_exception:'忽略异常',
        available_amount:'可退金额',
        refound_amount:'退款金额',
        remain_available_amount:'剩余可退款金额',
        fully_refunded:'交易已全额退款。',
        refund_delay_hour:'请在交易完成的{hour}小时后发起退款！'






    },
    refund:{
        mch_refund_no:'商户退款号',
        refund_stat:'退款状态',
        refund_type:'退款类型',
        refund_order_no:'退款订单号',
        order_amount:'订单金额',
        refund_amount:'退款金额',
        merchant_refund_amount:'商户退款金额',
        channel_refund_no:'渠道退款号',
        gateway_refund_amt:'网关退款金额',
        refund_type:'退款方式',
    },


    address_info:{
        shipping:'物流信息',
        shipping_address:'账单地址',
        state:'州/省',
        address:'地址',
        tel:'电话',
        postcard:'邮编',
        email:'邮箱',
        name:'姓名',
        shipping_allow:'物流追踪',
        first_name:'姓',
        last_name:'名',
        city:'城市',
        street:'街道',
        enable_all:'Enable all',
        disable_all:'Disable all',
        enable_page:'Enable this page',
        disable_page:'Disable this page'

    },
    express_info:{
        company_code:'公司名称缩写/编码',
        edit:'编辑',
        add:'新增',
        update_shipping_no:'更新运单号'


    },
    shipping:{
        is_shipping:'是否妥投',
        upload_time:'上传时间',
        create_time:'创建时间',
        express_company:'物流公司'
    },

    config:{
        icon:'Icon图标',
        emailLogo:'邮箱LOGO',
        merchant_web_siet:'商户前端域名',
        api_resourse:'api接口域名',
        service_api:'后台管理域名',
        icp:'备案号',
        solgan:'Slogan',
        institution_name_name:'机构名称',
        support_area:'业务支持地区',
        is_open_gateway:'启用网关',
        is_closed_web:'禁用前台',
        support_currency:'支持货币',
    },
    member_info:{
        two_fa:"二因子验证"
    },
    notice_info:{
        add_lang:'添加多语言',
        lang_text:"现在可以添加多语言系统通知了!",        
        all:'全部',
        merchant:'商户',
        merchant_list:'商户列表'

    },
    batchadd:{
        xlsx_text:'请下载妥投批量新增的xlsx文件，请按照文件中的格式要求，添加上您的妥投信息，填写完毕后，点击按钮上传即可.',
        app_text:'请下载APP批量新增的xlsx文件，请按照文件中的格式要求，添加上您的APP信息，填写完毕后，点击按钮上传即可 ',
        white_text:'请下载白名单批量新增的xlsx文件，请按照文件中的格式要求，添加上您的白名单信息，填写完毕后，点击按钮上传即可 ',
    },
    account_status:{
        1:'激活',
        2:'禁用',
        3:'受限制'
    },
    app_status:{
        0:'待审核',        
        1:'激活',
        2:'审核失败',
    },
    withdraw_status:{
        1:'提现成功', 
        2:'待审核', 
        3:'提现拒绝', 
        4:'待付款',
    },    
    statement_info:{
        total:'保证金总额',
        change:'保证金变化'
    },
    channel_info:{
        merchant_secret:'商户秘钥',
        version:'版本信息',
        vaild:'Valid',
        invaild:'Invaild'
    },
    role:{
        title:'角色组名',        
    },
    index_review:{
        all:"全部交易",
        success:'支付成功', 
        authorized:'已授权 ',
        captured:'已捕捉',
        refound:'已退款',
        chargeback:'已拒付',
        pending:'待支付',
        voided:'取消交易',
        failed:'支付失败',
        pending_refound:'等待退款',
        cancel_protest:'拒付撤销',
        get_protest:'收到的拒付',
        stataic_time:'按拒付时间统计'


    },
    statement_type:{
        1:'交易成功',                                
        2:'退款',
        3:'拒付',
        4:'释放保证金',
        5:'提现',
        6:'取消提现',
        7:'对账转入',
        8:'对账转出',
        9:'交易拒绝',
        // <!-- 10:交易预争议, -->
        11:'拒付撤销',
        12:'冻结资金',
        13:'解除冻结',
        // 14:"账户对账",
        // 15:"退款失败",
        20:'交易费用',
        21:'拒付费用',
        22:'退款费用',
        23:'提现费用',
        24:'其他费用',
    },

    
    //邮件类型
    email_type:{
        withdraw_success_notify:'提现成功',
        withdraw_success_notify_desc:'当商户提现操作被平台审核通过并处理的时候，通知到商户',
        merchant_payment_notify:'交易成功发送给商户', 
        merchant_payment_notify_desc:'交易支付成功，通知到商户', 
        customer_payment_notify:'交易成功发送给顾客', 
        customer_payment_notify_desc:'交易支付成功，通知到顾客', 
        withdraw_rejected_notify:'提现失败', 
        withdraw_rejected_notify_desc:'当商户提现操作被平台审核拒绝的时候，通知到商户', 
        trans_in_notify:'人工对账转入', 
        trans_in_notify_desc:'系统在人工对账转入资金的时候，通知到商户', 
        trans_out_notify:'人工对账转出', 
        trans_out_notify_desc:'系统在人工对账转出资金的时候，通知到商户', 
        frozen_notify:'人工冻结', 
        frozen_notify_desc:'人工冻结商户资金的时候，通知到商户', 
        unfreeze_notify:'人工解冻', 
        unfreeze_notify_desc:'人工解冻商户资金的时候，通知到商户', 
        charge_back_notify:'交易拒付/欺诈',
        charge_back_notify_desc:'系统在处理交易拒付/欺诈的时候，通知到商户',
        cancel_charge_back_notify:'拒付撤销',
        cancel_charge_back_notify_desc:'系统在处理拒付撤销的时候，通知到商户',
        fee_notify:'费用收取',
        fee_notify_desc:'系统在处理费用收取的时候，通知到商户',



    },
    merchant:{
        add:'创建商户',
        company_info:'公司信息',
        honor_info:'资质信息',
        honor:'企业资质',
        file_info:'资料说明',
        zip:"以上文件打包为zip,rar文件上传,文件大小不能超过8M。<span class='uk-text-danger'>( 添加的文件会覆盖之前添加的文件  )</span>",
        terms_text:'通过提交本表，表示您确认您同意平台服务条款，同意接受来自平台的的自动邮件，并确认您提供的信息是完整和准确的.',
        confirm_apply:'提交审核',
        save:'保存供以后使用',
        update_merchant:'更新商户信息',
        kyc:'KYC资料',
        uploaded:'文件上传中...',
        tips:' 资料说明',
        nopost_text:'当前商户号尚未提交审核!',
        applying_text:'当前商户号正在审核中,请耐心等待!',
        close_text:'当前商户号已禁用!',


        back_index:'返回首页',
        legal_info:'法人信息',
        withdraw_range:'提现范围',
        no_limit:'不限制',
        is_open_white:'是否开启白名单',
        email_config:'邮件通知配置',
        // email_tips:'你可以为每个商户号自定义邮件通知，内容会发送到：',  
        email_tips:'你可以为每种邮件类型自定义接收邮箱，如果不设置，内容会发送到：',   
        custom_email:'您的自定义邮箱',

    },
    withdraw:{
        withdraw_list:'提现列表',
        my_bank:'我的银行',
        withdraw_amt:'提现金额',
        add_bank:'添加银行',
        withdraw_now:'现在提现',
        tips:'您的商户号无法使用提现功能，请及时发送邮件到 {email}，联系我们！',
        no_bank:'你还没有绑定银行账户！',
        available_withdraw_amount:'可提现金额',
        card_info:'银行账号',
        bank_address:"银行地址",
        if_any:'中转行信息 (If any)',
        payee_country:'收款人国家',
        payee_address:'收款人地址',
        withdraw_text:'请确保输入的帐户信息准确无误，因信息录入错误导致的转账问题，平台概不负责！',
        add_bank_text_1:'注意！您只能添加银行帐户名为 <span class="uk-text-danger"><i>{name}</i></span> 的银行帐户！请在添加前，确保该帐户可以接受 <span class="uk-text-danger"><i>{currency}</i></span>货币 ',
        add_bank_text_2:'注意！请在添加前，确保帐户可以接受<span class="uk-text-danger"><i>{currency}</i></span>货币',        
    },
    file_info:{        
        1:'a）企业注册证书彩色影印件，需要能够清晰的看到企业名称，注册号码，注册时间，注册地址',
        2:'b）所有董事的ID或者护照的彩色影印件',
        3:'c）超过25%的所有UBO的ID或者护照彩色影印件',
        4:'d）至少两张公司所有者的近照 ',
        5:'e）至少一个授权代表的名片（可选）',
        6:'f）至少两张带有公司名或者品牌名的办公室照片 ',
        7:'g）近三个月内公司水电煤气的电子版照片 ',
        8:'h）近三个月公司银行账单的电子版照片',


    },
    risk_type:{
        1:'IP',
        2:'国家',
        3:'邮箱',
        4:'电话',            
        5:'信用卡卡号'
    },
    egret_server:{
        1:'实体商品',
        2:'广告/市场营销/媒体服务',
        3:'电气电缆本地服务',
        4:'工程服务',
        5:'活动管理会员服务/预订服务',
        6:'招聘/人力资源服务',
        7:'会员俱乐部/乡村俱乐部/私人高尔夫球课程服务',
        8:'财务支持 ',
        9:'件支持/文件存取/PC支持 ',
        10:'下载服务（音乐/电影/电子书/图片）',
        11:'社交服务',
        12:'多层次营销 ',
        13:'住宿酒店/汽车旅馆/度假村/分时度假/旅游类',
        14:'营养药品/皮肤护理/天然补充剂 ',
        15:'天然草本植物 /植物药类',
        16:'化学制品 ',
        17:'电子烟/烟草 ',
        18:'仿品类 ',
        19:'游戏类 ',
        20:'成人类',
        21:'药店和药房',
        22:'其他类'       
    }
}


// WEBPACK FOOTER //
// ./src/components/common/resouces/lang/zh.js